<div class="dialog-header">
    <h2 mat-dialog-title>Edit Fund Valuation Description</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <form [formGroup]="fundValuationDescriptionForm">
        <mat-form-field appearance="fill" class="description-form-field">
            <mat-label>Description</mat-label>
            <input matInput
                   data-test="fund-valuation-description-input"
                   formControlName="description">
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button
        mat-stroked-button mat-dialog-close
        color="primary"
        data-test="save-button"
        [disabled]="fundValuationDescriptionForm.invalid"
        (click)="saveFundValuationDescription()">
        Save
    </button>
</mat-dialog-actions>
